import React from 'react'
import { CommonContext } from '@ssr/context'
import qs from 'qs'
import $ from 'jquery'
import TutorialApi from '../api'

import './index.less'
import ThinkingDataSDK from '@ssr/components/Analytics/ThinkingDataSdk'
import VolcEngine from '@ssr/components/Analytics/VolcEngine'

const cache = {}
let loading = true
function getData(app, { manual_type, category_id }) {
  const $block = $('.page .block')

  function renderList(list) {
    return list
      .map((article) => {
        return /* html */ `<a class="article" href="${article.webview}" style="background-image: url('${article.cover_type === 'video' ? article.default_cover : article.cover}');" data-id="${
          article.id
        }" data-category="${manual_type}">${article.title ? '<div class="text-group"><div class="text">' + article.title + '</div></div>' : ''}</a>`
      })
      .join('')
  }

  const list = cache[`${app}:${category_id || manual_type}`]
  if (list) {
    $block.empty().append(renderList(list))
  } else {
    const promise = category_id
      ? TutorialApi.getTutorialItems({
          category_id,
        })
      : TutorialApi.getManuals({
          app,
          manual_type,
        })

    promise.then((res) => {
      if (res.code === 0) {
        cache[`${app}:${category_id || manual_type}`] = res.data.list

        $block.empty().append(renderList(res.data.list))

        if (app === 'oner') {
          if (loading) {
            loading = false
            ta.track('story_tutorial_load_finish')
          }
        }
      }
    })
  }
}

function init({ _app, subMap }) {
  const $nav = $('.page .nav')

  const navList = subMap[_app] || subMap['go']

  navList.forEach(function (item) {
    $nav.append($(`<div class="nav-item">${item.text}</div>`))
  })

  let currentIndex = -1
  function changeIndex(index) {
    const $navItems = $('.page .nav-item')

    $navItems.removeClass('active').eq(index).addClass('active')
    getData(_app, navList[index])

    currentIndex = index
  }

  $('.page .nav-item').click(function () {
    const index = $(this).index()
    if (currentIndex === index) {
      return
    }

    changeIndex(index)

    if (_app === 'oner') {
      if (navList[index].manual_type === 'app') {
        ta.track('click_story_app_tutorial')
      } else {
        ta.track('click_story_camera_tutorial')
      }
    }
  })
  changeIndex(0)
}

function useThingkingdata() {
  const $page = $('.page')

  $page.on('click', '.article', function () {
    const story_tutorial_id = $(this).attr('data-id')
    const story_tutorial_url = $(this).attr('href')
    const story_tutorial_category = $(this).attr('data-category')

    ta.track('click_story_specific_tutorial', { story_tutorial_id, story_tutorial_url, story_tutorial_category })
  })
}

function Page({ _app }) {
  const { __, isOversea } = React.useContext(CommonContext)
  const subMap = React.useMemo(() => {
    return {
      oner: [
        {
          text: __['app.tutorial.manuals.tab_camera'],
          manual_type: 'camera',
        },
        {
          text: 'APP',
          manual_type: 'app',
        },
      ],
      go: [
        {
          text: __['app.tutorial.manuals.tab_camera'],
          manual_type: 'camera',
        },
        {
          text: 'APP',
          manual_type: 'app',
        },
      ],
      onex: [
        {
          text: isOversea ? 'Basic' : '相机教程',
          category_id: isOversea ? '12' : '14',
        },
      ],
    }
  }, [__])
  React.useEffect(() => {
    init({ _app, subMap })
    if (_app === 'oner') {
      useThingkingdata()
    }
  }, [])
  return (
    <>
      <div className='page'>
        <div className='nav'></div>
        <div className='block'></div>
      </div>
      <ThinkingDataSDK />
      <VolcEngine />
    </>
  )
}

Page.injectData = function ({ locals }) {
  return {
    localeData: {
      namespaces: ['common', 'app'],
    },
  }
}

export const getServerSideProps = async ({ req, res }) => {
  const app = res.params.app || 'go'
  return {
    props: {
      _app: app,
    },
  }
}

export default Page
